import { Keys } from 'excalibur';
import { KeyboardLike } from './KeyboardLike';


export const button = (kb: KeyboardLike, key: Keys) => ({
    get holding() {
        return kb.isHeld(key);
    },
    get pressed() {
        return kb.wasPressed(key);
    },
});
